/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Value_TitleInputs */



/**
* | output |
* | --- |
* | "Wundo supports you in every conversation that matters" |
*
* @param {Onboarding_Value_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_value_title = /** @type {((inputs?: Onboarding_Value_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Value_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wundo ondersteunt je in elk belangrijk gesprek")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Wundo vous accompagne dans chaque conversation importante")
	return /** @type {LocalizedString} */ ("Wundo supports you in every conversation that matters")
});